import dayjs from 'dayjs';

import type { ChartPeriod } from '../types';

/**
 * Calculate the appropriate chart period based on date range
 * - Less than 31 days: daily
 * - Less than 91 days: weekly
 * - 91 days or more: monthly
 */
export function getDefaultChartPeriod(startDate: string, endDate: string): ChartPeriod {
  const start = dayjs(startDate);
  const end = dayjs(endDate);
  const daysDiff = end.diff(start, 'day');

  if (daysDiff < 31) {
    return 'daily';
  } else if (daysDiff < 91) {
    return 'weekly';
  } else {
    return 'monthly';
  }
}
